import React, { useEffect, useState } from 'react'
import ViewContentModal from '../components/modals/ViewContentModal';
import InsightsModal from '../components/modals/InsightsModal';

const ModalProvider = () => {

  const [isMounted, setIsMounted] = useState(false);
  
  useEffect(() => {
    setIsMounted(true);
  }, [])

  if (!isMounted) {
    return null;
  }

  return (
    <>
      <ViewContentModal />
      <InsightsModal />
    </>
  )
}

export default ModalProvider;